<script lang="ts">
    import {
        Navbar_MyNotificationsQueryDocument,
        NotificationFragmentDoc,
    } from '$gql/graphql';
    import { getContainer } from '$components/Context/ContainerContext';
    import { useFragment } from '$gql';
    import { type MeltWithAction, meltWithActionDefault } from '$lib/utils/melt';
    import NotificationRow from '$components/Notification/NotificationRow.svelte';
    import { melt } from '@melt-ui/svelte';
    import * as t from '$trans';
    import { query } from '$lib/apollo/SvelteApollo';
    import NotificationRowSkeleton from '$components/Notification/NotificationRowSkeleton.svelte';
    import { rangeLeft } from '$lib/utils/range';

    export let meltItem: MeltWithAction = meltWithActionDefault;

    const { urlHelper, lang } = getContainer();

    const { result } = query(Navbar_MyNotificationsQueryDocument, {});
</script>

<div>
    <div>
        {#if $result.data != null}
            {#each $result.data.myNotifications.results as n}
                <NotificationRow
                    notification={useFragment(NotificationFragmentDoc, n)}
                    {meltItem}
                />
            {/each}
        {:else if $result.loading}
            {#each rangeLeft(0, 6) as _i}
                <NotificationRowSkeleton />
            {/each}
        {/if}
    </div>
    <div class="px-[16px] pt-[8px] pb-[12px]">
        <a
            use:melt={meltItem}
            class="btn-leo btn-leo-gray-blue btn-xl w-full"
            href={urlHelper().notificationList()}
            data-sveltekit-reload={false}
        >
            {t.navbar.notification_see_all({}, $lang)}
        </a>
    </div>
</div>
